<template>

    <div class="card blog blog-primary overflow-hidden rounded shadow border-0 card-course">
        <div class="position-relative d-block overflow-hidden">
            <img :src="course?.image ?? '/assets/images/contact-detail.jpg'" class="img-fluid rounded-top mx-auto" alt="">
            <div class="overlay"></div>

            <router-link :to="{name: 'courses.show', params: { id: course.id }}"   class="h6 preview bottom-0 end-0 me-4 mb-3" >
                Preview Now <i class="uil uil-angle-right-b align-middle"></i>
            </router-link>

        </div>

        <div class="card-body content">
            <router-link :to="{name: 'courses.show', params: { id: course.id }}" class="title text-dark h5">
                {{ course?.name }}
            </router-link>
            <p class="text-muted">{{ course?.description }}</p>

            <!--                            <div class="rating mt-2">-->
            <!--                                <ul class="list-unstyled mb-0">-->
            <!--                                    <li class="list-inline-item"><i class="mdi mdi-star h6 mb-0 text-warning"></i></li>-->
            <!--                                    <li class="list-inline-item"><i class="mdi mdi-star h6 mb-0 text-warning"></i></li>-->
            <!--                                    <li class="list-inline-item"><i class="mdi mdi-star h6 mb-0 text-warning"></i></li>-->
            <!--                                    <li class="list-inline-item"><i class="mdi mdi-star h6 mb-0 text-warning"></i></li>-->
            <!--                                    <li class="list-inline-item"><i class="mdi mdi-star-outline h6 mb-0 text-warning"></i></li>-->
            <!--                                    <li class="list-inline-item">3.99 Star (11 <i class="uil uil-user text-muted small"></i>)</li>-->
            <!--                                </ul>-->
            <!--                            </div>-->
            <!--                            <div class="fees d-flex justify-content-between">-->
            <!--                                <ul class="list-unstyled mb-0 numbers">-->
            <!--                                    <li><i class="uil uil-graduation-cap text-muted"></i> 30 Students</li>-->
            <!--                                    <li><i class="uil uil-notebooks text-muted"></i> 5 Lession</li>-->
            <!--                                </ul>-->
            <!--                                <h4><span class="h6">$</span>150</h4>-->
            <!--                            </div>-->
        </div>
    </div>

</template>

<script>
export default {
    name: "course-card",
    props: ['course'],
    data() {
        return {
        }
    },
    async created() {

    },
    methods: {

    }
}
</script>

<style scoped>

</style>
